import { Button, Form, Input, Modal, Select, Space, TimePicker } from "antd";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import axios from "axios";
import { NotificationInfo } from "../../../../context";
import moment from "moment";

const EditSchedule = ({ open, close, rerun, specificData }) => {
  const [form] = Form.useForm();
  const [timeIn, setTimeIn] = useState(
    specificData.start_datetime !== null ? specificData.start_datetime : null
  );
  const [timeOut, setTimeOut] = useState(
    specificData.end_datetime !== null ? specificData.end_datetime : null
  );
  const [scheduleStatus, setScheduleStatus] = useState(
    specificData.schedule_status !== null ? specificData.schedule_status : null
  );
  const { rerunNotif } = useContext(NotificationInfo);

  const handleUpdateScheduleLog = () => {
    const formdata = new FormData();
    formdata.append("id", specificData.id !== null ? specificData.id : "");
    formdata.append("start_datetime", timeIn);
    formdata.append("end_datetime", timeOut);
    formdata.append("schedule_status", scheduleStatus);

    axios
      .post("user/merchant/update/employee-schedule", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated schedule successfully.");
          setTimeout(() => {
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="edit-schedule"
        initialValues={{
          start_datetime:
            specificData.start_datetime !== null
              ? dayjs(specificData.start_datetime, "HH:mm:ss")
              : null,
          end_datetime:
            specificData.end_datetime !== null
              ? dayjs(specificData.end_datetime, "HH:mm:ss")
              : null,
          schedule_status:
            specificData.schedule_status !== null
              ? specificData.schedule_status
              : "",
        }}
        onFinish={handleUpdateScheduleLog}
        autoComplete="off"
        form={form}
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="schedule_status"
            label="Status"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select status"
              onChange={(e) => setScheduleStatus(e)}
              size="large"
              //   showSearch
            >
              <Select.Option value={1}>Active</Select.Option>
              <Select.Option value={0}>Rest</Select.Option>
            </Select>
          </Form.Item>

          {parseInt(scheduleStatus) === 1 && (
            <>
              <Form.Item
                name="start_datetime"
                label="Start Time"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <TimePicker
                  format={"HH:mm"}
                  onChange={(value, dateString) => {
                    if (dateString !== "") {
                      var date = `2023-11-23 ${dateString}:00`;
                      var finalDate = moment(
                        `${date.replace(" ", "T")}.000000Z`
                      )
                        .utc()
                        .format("HH:mm:ss");
                      setTimeIn(finalDate);
                    } else {
                      setTimeIn(null);
                    }
                  }}
                  size="large"
                  required
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Form.Item
                name="end_datetime"
                label="End Time"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <TimePicker
                  format={"HH:mm"}
                  onChange={(value, dateString) => {
                    if (dateString !== "") {
                      var date = `2023-11-23 ${dateString}:00`;
                      var finalDate = moment(
                        `${date.replace(" ", "T")}.000000Z`
                      )
                        .utc()
                        .format("HH:mm:ss");
                      console.log("FINAL DATE: ", finalDate);
                      setTimeOut(finalDate);
                    } else {
                      setTimeOut(null);
                    }
                  }}
                  size="large"
                  required
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </>
          )}
        </Space>

        <Form.Item style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditSchedule;
